<template>
  <v-container grid-list-xs>
    <v-card>
      <v-card-title primary-title> List Of Other Costs </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-data-table
          :loading="loading"
          :headers="headers"
          :items="OtherCosts"
          :items-per-page="10"
        >
          <!-- <template v-slot:item.payment="{ item }">
            <DepositeOtherCost
              :Title="item.CostName"
              :BaseURL="`${SuppURL}/deposit`"
              :OtherCost="item"
            ></DepositeOtherCost>
          </template> -->
          <template v-slot:[`item.more`]="{ item }">
            <base-row-layout>
              <!-- Edite Icon -->
              <div>
                <v-btn icon color="primary">
                  <v-icon class="mr-2" @click="OtherCostEdite(item)">
                    fas fa-pencil-alt
                  </v-icon>
                </v-btn>
              </div>
              <!-- Show Balance Icon -->
              <div>
                <ShowBalance
                  :ReqURL="`${SuppURL}/balance`"
                  :Title="item.CostName"
                  :query="{ _id: item._id }"
                >
                </ShowBalance>
              </div>
              <!-- Transaction view Icon -->
              <div>
                <OtherCostTran
                  :BaseURL="SuppURL"
                  :Title="item.CostName"
                  :TranInfo="item"
                  :headers="headersTran"
                ></OtherCostTran>
              </div>
            </base-row-layout>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <NewCost
          :OnEdite="OnEdite"
          :isEditing="isEditing"
          :OnFinish="Onfinshed"
          @input="isEditing = $event"
        ></NewCost>
      </v-card-actions>
    </v-card>
  </v-container>
</template>
<script>
export default {
  components: {
    NewCost: () => import("@/components/HQ/otherCost/NewCost.vue"),
    // DepositeOtherCost: () => import("@/components/util/costDeposit.vue"),
    OtherCostTran: () => import("@/components/util/TranSactionView.vue"),
    ShowBalance: () => import("@/components/util/showBalance.vue"),
  },
  data() {
    return {
      SuppURL: "/supplier/other",
      isEditing: false,
      loading: false,
      OtherCosts: [],
      headers: [
        {
          text: "Cost Name",
          align: "left",
          value: "CostName",
          class: "teal darken-3 white--text",
        },
        {
          text: "Contact",
          value: "Contact",
          class: "teal darken-3 white--text",
        },
        {
          text: "Details",
          value: "Details",
          class: "teal darken-3 white--text",
        },
        {
          text: "Cash",
          value: "CashType",
          class: "teal darken-3 white--text",
        },

        {
          text: "More",
          value: "more",
          align: "center",
          class: "teal darken-3 white--text",
          sortable: false,
        },
      ],
      OnEdite: {},
      headersTran: [
        {
          text: "Date",
          align: "left",
          value: "date",
        },
        { text: "Details", value: "Details" },
        { text: "Cash Type", value: "AmountType" },
        { text: "Deposit", value: "deposit" },
        { text: "Withdrawal", value: "withdraw", class: "blue--text" },
        { text: "Reason", value: "Reason" },
        { text: "User", value: "User" },
        { text: "Ref", value: "Ref" },
      ],
    };
  },

  methods: {
    OtherCostEdite(E_Supp) {
      // console.log(E_Supp);
      this.isEditing = true;
      this.OnEdite = E_Supp;
    },

    loadAllOtherCost() {
      this.loading = true;
      this.$store
        .dispatch("GET_ONLY", this.SuppURL)
        .then(result => {
          // console.log(result)
          this.OtherCosts = result.data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    Onfinshed(result) {
      this.OtherCosts = result;
      this.isEditing = false;
    },
  },
  mounted() {
    this.loadAllOtherCost();
  },
};
</script>
